$(document).ready(function(){
	const notificationEl = $('.notification');

	// -- upload file(s) --
	$(document).on('change', '.organizersForm input', function(e) { 
    e.preventDefault();
		var $form = $(this).parents('form');
    submitForm($form);
	});

	// -- save entry --
	function submitForm($form) {
		var formData = new FormData($form[0]);
		$form.find('.form__content').css({'opacity': '.1'});
		$form.find('.icon--loader').removeClass('hidden');
		$.ajax({
			type: "POST",
			url: $form.find('input[name=action]').val(),
			dataType: 'json',
			data: formData,
			contentType: false,
			processData: false,
			success: function (response) {
				// console.log(response);
				notificationEl.find('.notification__inner').text(response.message);
				notificationEl.removeClass('-translate-y-40');
				
				// -- update dashboard template --
				$.ajax({
					url: window.location.href,
					type: 'GET',
					success: function(updatedEntryData){
						// console.log(updatedEntryData);
						var updatedForm = $(updatedEntryData).find(`#${$form[0].id}`).parent().html();
						$form.parent().html(updatedForm);
					  $('.section').removeClass('section--locked');
					  $('.section.locked__content').hide();						
					},
					error: function (error) {
						// console.log(error);
						window.location.reload();
					},
					complete: function() {
						$form.find('.form__content').css({'opacity': '1'});
						$form.find('.icon--loader').addClass('hidden');
					}
				});				
    	},
			error: function (error) {
				// console.log(error);
				notificationEl.find('.notification__inner').text(error.message);
				notificationEl.removeClass('-translate-y-40');
				window.location.reload();
			},
			complete: function (xhr) {
				// console.log(xhr);
				$form.find('.form__content').css({'opacity': '1'});
				$form.find('.icon--loader').addClass('hidden');
				setTimeout(function(){
					notificationEl.addClass('-translate-y-40');
				}, 2500);
				setTimeout(function(){
					notificationEl.find('.notification__inner').text('');
				}, 5000);
			}
		});
	}

	// -- multi upload : delete files --
	$('.deleteFileForm').on('submit', function(e){
		e.preventDefault();
		var $form = $(this);
		var formData = new FormData($(this)[0]);
		$.ajax({
			type: "POST",
			url: $(this).find('input[name=action]').val(),
			dataType: 'json',
			data: formData,
			contentType: false,
			processData: false,
			success: function (response) {
				notificationEl.find('.notification__inner').text(response.message);
				notificationEl.removeClass('-translate-y-40');
				$form.parents('.fileElement').remove();
    	},
			error: function (error) {
				window.location.reload();
			},
			complete: function (xhr) {
				setTimeout(function(){
					notificationEl.addClass('-translate-y-40');
				}, 2500);
				setTimeout(function(){
					notificationEl.find('.notification__inner').text('');
				}, 5000);
			}
		});
	});

});